import React from 'react';
import Helmet from 'react-helmet';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import * as dialog from '../components/FieldTreeDialog';
import * as api from '../services/FieldTree';
import {
  USER_ROLES,
  HEADER_CONSTANTS,
  API_FLAG,
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  INTEGRATE_USER_SUCCESS_TITLE,
  INTEGRATE_USER_SUCCESS_MESSAGE,
} from '../utilities/constants';
import dialogLoader from '../utilities/dialogLoader';
import fetchMg from '../utilities/fetchManager';
import masterSlideLoader from '../utilities/masterSlideLoader';
import slideLoader from '../utilities/slideLoader';
import regex from '../utilities/validateRegex';
import { FieldTreeService } from '../services/FieldTrees';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { validateByJoi } from '../utilities/validation';
import { SupervisorForm } from '../components/forms/SupervisorForm';
import {
  isManagerRoleId,
  roleIdToJapaneseRoleName,
} from '../utilities/roleUtility';
import { ConfirmExistedEmailDialog } from '../components/modals/ConfirmExistedEmailDialog';
import { ConfirmIntegrateUserDialog } from '../components/modals/ConfirmIntegrateUserDialog';
import { IntegrateError } from '../components/modals/IntegrateError';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import FieldContractorUserService from '../services/FieldContractorUsers';
import { Information } from '../components/modals/common';
import { messageUtility } from '../utilities/messageUtility';
import EventManager, { EventType } from '../utilities/EventManager';

/**
 * @description 元請BOX詳細_現場監督新規登録画面
 * @props {string} view.state.id stringに変換されたパラメータ。JSONに変換が可能。
 */
export default class FieldTreeForm extends React.Component {
  constructor(props) {
    super(props);

    /**
     * パースした結果下記のプロパティが使用できる
     * {number} main_branch_id : FieldTreeService.decideCompanyBranchId で得られる役職取得用支店ID
     * {number} jvcbid : 不明（調査が必要）
     * {number} company_branch_id : 不明（調査が必要）
     * {number} constructor_user_id : 不明（調査が必要）
     * {number} jv_company_branch_id : 不明（調査が必要）
     */
    const decoded = JSON.parse(decodeURIComponent(this.props.view.state.id)); //デコード

    // Get available roles
    const { branch, manager } = USER_ROLES;
    const currentRole = Number(localStorage.getItem('role_id'));
    const roles = [branch, manager].filter(role => {
      if (currentRole <= USER_ROLES.prime.id) {
        return true;
      }

      if (currentRole > role.id) {
        return false;
      }

      return true;
    });

    this.state = {
      role_id: currentRole,
      field_id: sessionStorage.getItem('field_id'),
      data: {},
      jv: {},
      jv_id: decoded.jvcbid,
      company_branch_id: decoded.company_branch_id,
      constructor_user_id: decoded.constructor_user_id,
      jv_company_branch_id: decoded.jv_company_branch_id,
      position_company_branch_id: decoded.main_branch_id,

      requiredInput: {
        // 必須入力項目
        columns: [],
        // 必須総数
        total: 0,
        count: 1, // 入力数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      formValues: {
        approval_flag: '',
        company_id: '',
        role_name: '',
        name_sei: '',
        name_mei: '',
        kana_sei: '',
        kana_mei: '',
        tel: '',
        email: '',
        user_id: '',
        tel1: '',
        tel2: '',
        tel3: '',
      },
      disabledFields: [],
      roles,

      validatingTel: false,
      validTel: false,
      my_branch: isManagerRoleId(Number(localStorage.getItem('role_id')))
        ? API_FLAG.On
        : API_FLAG.Off,
      showConfirmExistedEmailDialog: false,
      showConfirmIntegrateUserDialog: false,
      showIntegrateError: false,
      showInformationModal: false,
      integrateSuccessModal: null,
      integrateErrorMessage: null,
      listIntegrateUsers: null,
      errorMessage: '',
    };

    this.schemaDefinition = {
      position_id: Joi.number()
        .required()
        .error(() => ({ type: 'any.required' })),
      approval_level: Joi.number()
        .required()
        .error(() => ({
          type: 'any.required',
        })),
      company_branch_id: Joi.number()
        .required()
        .error(() => ({ type: 'any.required' })),
    };

    this.updatingFlag = false; // 多重更新防止Flag

    // constructor_user_idがなければ新規登録
    this.isNewMode = isNullOrUndefinedOrEmptyStr(
      this.state.constructor_user_id
    );

    if (this.isNewMode && roles.length === 1) {
      // Select first item in list of available role for new mode
      // since role item will be label instead of radio button
      this.state.formValues = {
        ...this.state.formValues,
        role_code: roles[0].id,
        role_name: roles[0].name,
      };
    }

    this.form = {
      set: this.setData,
      isValid: this.isValid,
    };
    this.tempParamFetch = null;
  }

  componentDidMount() {
    this.getConstructorData();

    let requiredFields = ['position_id', 'approval_level'];
    if (!this.isNewMode) {
      //検索して追加から追加する場合
      fetchMg
        .GetAjax(`/api/private/users/${this.state.constructor_user_id}`, {})
        .then(data => {
          if (data.result) {
            let user = data.data.entities.user;
            let user_role = data.data.entities.user.user_role;
            let disabledFields = [
              'name_sei',
              'name_mei',
              'kana_sei',
              'kana_mei',
              'tel1',
              'tel2',
              'tel3',
              'email',
            ];

            const [tel1, tel2, tel3] = isNullOrUndefinedOrEmptyStr(user.tel)
              ? ['', '', '']
              : user.tel.split('-');

            this.setState({
              formValues: {
                approval_flag: '',
                company_id: user.company_id,
                company_branch_id: user.company_branch[0].id,
                company_branch_name: user.company_branch[0].name,
                role_code: parseInt(user_role.code),
                role_name: roleIdToJapaneseRoleName(user_role.code),
                user_id: user.id,
                name_sei: user.name_sei,
                name_mei: user.name_mei,
                kana_sei: user.kana_sei,
                kana_mei: user.kana_mei,
                email: user.email,
                tel: user.tel,
                tel1,
                tel2,
                tel3,
              },
            });

            // Disable role code radio buttons if role code is currently selected
            if (
              [USER_ROLES.branch.id, USER_ROLES.manager.id].includes(
                parseInt(user_role.code)
              )
            ) {
              this.handleChangeBranch(API_FLAG.On);
              disabledFields = [...disabledFields, 'role_code'];
            }

            if (user.company_branch[0].id) {
              disabledFields = [...disabledFields, 'company_branch_id'];
            }

            this.setState({
              disabledFields,
            });
          }
        });
    } else {
      requiredFields = [
        ...requiredFields,
        'company_branch_id',
        'role_code',
        'name_sei',
        'name_mei',
        'kana_sei',
        'kana_mei',
        'email',
      ];

      this.schemaDefinition = {
        ...this.schemaDefinition,
        name_sei: Joi.string()
          .required()
          .max(64),
        name_mei: Joi.string()
          .required()
          .max(64),
        kana_sei: Joi.string()
          .required()
          .max(128)
          .regex(regex.pattern.hiragana)
          .label('hiragana'),
        kana_mei: Joi.string()
          .required()
          .max(128)
          .regex(regex.pattern.hiragana)
          .label('hiragana'),
        email: Joi.string()
          .required()
          .regex(regex.pattern.email),
        tel: Joi.string()
          .allow('--', '')
          .regex(regex.pattern.tel),
        role_code: Joi.number().required(),
      };
    }

    this.schema = Joi.object().keys(this.schemaDefinition);
    this.setState(
      {
        requiredInput: {
          ...this.state.requiredInput,

          // 必須入力項目
          columns: requiredFields,
          // 必須総数
          total: _.size(requiredFields),
          count: 0, // 入力数
        },
      },
      () => {
        // Set default role based on current user role
        if (
          this.isNewMode &&
          [USER_ROLES.branch.id, USER_ROLES.manager.id].includes(
            this.state.role_id
          )
        ) {
          this.handleChangeBranch(API_FLAG.On);
          this.setData('role_code', this.state.role_id);
        }
      }
    );
  }

  async getConstructorData() {
    //JV情報
    if (this.state.jv_id) {
      const JVLists = await api.JVListsData(this.state.field_id);
      if (JVLists.entities && JVLists.entities.company.length) {
        this.setState({
          jv: _.filter(JVLists.entities.company, c => {
            return c.company_branch_id === this.state.company_branch_id;
          }).shift(),
        });
      }
    }
  }

  /**
   * 入力
   */
  setData = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = value;

    // Handling for special case
    switch (name) {
      case 'tel1':
      case 'tel2':
      case 'tel3':
        if (
          _.isEmpty(formValues.tel1) &&
          _.isEmpty(formValues.tel2) &&
          _.isEmpty(formValues.tel3)
        ) {
          formValues.tel = '';
        } else {
          formValues.tel = `${formValues.tel1}-${formValues.tel2}-${
            formValues.tel3
          }`;
        }
        break;
    }

    const { messages: validateMessages = {} } = validateByJoi(
      this.schema,
      formValues
    );

    // 必須チェック
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    requiredInput.count = _.reduce(
      this.state.requiredInput.columns,
      (accum, item) => {
        if (formValues[item] && !validateMessages[item]) {
          accum++;
        }
        return accum;
      },
      0
    );

    this.setState({
      requiredInput,
      formValues,
    });
  };

  /**
   * 入力値の有効判定
   * @return bool
   */
  isValid = (e, targetName) => {
    const values = _.cloneDeep(this.state.formValues);
    const validate = _.cloneDeep(this.state.validate);
    const result = validateByJoi(this.schema, values);
    const available = result.result;

    // if  - onBlur時に入力チェック
    // else- submit(登録ボタン押下)時に必須項目チェック
    if (e) {
      const name = _.isEmpty(targetName) ? e.target.name : targetName;
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
      } else if (_.has(validate.messages, name)) {
        delete validate.messages[name];
      }
    } else {
      validate.messages = {};
      if (!available) {
        _.each(result.messages, (value, key) => {
          validate.messages[key] = result.messages[key];
        });
      }
    }

    // error有無チェック、フラグ変更
    if (Object.keys(validate.messages).length !== 0) {
      validate.invalid = true;
    } else {
      validate.invalid = false;
    }

    this.setState({ validate });
    return validate.invalid;
  };

  back() {
    let param = {
      id: this.state.company_branch_id,
      jvcbid: this.state.jv_id,
    };
    const _param = encodeURIComponent(JSON.stringify(param));
    slideLoader.show('ContractorBox', { state: { id: _param } }, this.props.vw);
  }

  async submit() {
    if (this.isValid()) {
      return;
    }

    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const json = _.cloneDeep(this.state.formValues);

    if (!this.isNewMode) {
      json.company_branch_id = this.state.data.company_branch_id;
    }

    const param = {
      position_id: parseInt(json.position_id),
      approval_level: parseInt(json.approval_level),
      approval_flag: json.approval_flag ? parseInt(json.approval_flag) : 0,
    };

    const user = {
      user: {
        company_id: this.state.prev_id,
        company_branch_id: json.company_branch_id,
        role_code: parseInt(json.role_code),
        role_name: json.role_name,
        name_sei: json.name_sei,
        name_mei: json.name_mei,
        kana_sei: json.kana_sei,
        kana_mei: json.kana_mei,
        email: json.email,
        tel: json.tel,
      },
    };

    if (
      _.has(this.state.formValues, 'user_id') &&
      this.state.formValues.user_id
    ) {
      param.user_id = this.state.formValues.user_id;
    }

    // JV(JointVenture)の情報を伝達する
    //  情報元：  src/pages/FieldTreeContractorBox.jsx
    param.jv_company_branch_id = this.state.jv_company_branch_id;

    if (this.isNewMode) {
      _.merge(param, user);
      const res = await LoginUserGroupsService.checkDuplicateEmail({
        email: param.user.email,
        user_role_code: param.user.role_code,
        company_id: param.user.company_id,
        company_branch_id: param.user.company_branch_id,
      });
      if (res.result) {
        this.updatingFlag = false;
        this.tempParamFetch = param;
        this.setState({ showConfirmExistedEmailDialog: true });
        return;
      }
    }
    fetchMg
      .PostAjax(
        `/api/private/fields/${this.state.field_id}/field_contractor_users`,
        param
      )
      .then(data => {
        if (data.result) {
          dialogLoader.show(dialog.submitSuccess, {
            callback: {
              done: () => {
                dialogLoader.close();
                masterSlideLoader.show(
                  'ContractorBox',
                  { state: { id: this.generateParams() } },
                  this.props.vw
                );
              },
            },
          });
        }
      })
      .catch(e => {
        this.setState({
          showInformationModal: true,
          errorMessage: e[0].responseJSON.message,
        });
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  }

  generateParams() {
    let param = {
      id: this.state.company_branch_id,
      jvcbid: this.state.jv_id,
    };
    return encodeURIComponent(JSON.stringify(param));
  }

  close() {
    dialogLoader.show(dialog.CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          dialogLoader.close();
          masterSlideLoader.show(
            'ContractorBox',
            { state: { id: this.generateParams() } },
            this.props.vw
          );
        },
      },
    });
  }

  handleChangeBranch = branch => {
    this.setState({
      my_branch: branch,
    });
  };

  closeDialog = stateName => {
    this.setState({ [stateName]: false });
    if (this.tempParamFetch) {
      this.tempParamFetch = null;
    }
    if (
      stateName === 'showInformationModal' &&
      this.state.integrateSuccessModal
    ) {
      masterSlideLoader.show(
        'ContractorBox',
        { state: { id: this.generateParams() } },
        this.props.vw
      );
    }
  };

  confirmIntegrate = () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    LoginUserGroupsService.checkIntegrate({
      email: this.tempParamFetch.user.email,
      user_role_code: this.tempParamFetch.user.role_code,
      company_id: this.tempParamFetch.user.company_id,
      company_branch_id: this.tempParamFetch.user.company_branch_id,
    })
      .then(res => {
        if (res.result) {
          this.setState({
            listIntegrateUsers: _.get(res, 'data.entities.users'),
            showConfirmExistedEmailDialog: false,
            showConfirmIntegrateUserDialog: true,
          });
        } else {
          this.setState({
            integrateErrorMessage:
              _.get(res, 'data.message') ||
              messageUtility.getMessage('E-000-001'),
            showConfirmExistedEmailDialog: false,
            showIntegrateError: true,
          });
        }
      })
      .finally(() => {
        this.updatingFlag = false;
      });
  };

  confirmIntegrateUser = () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    FieldContractorUserService.createContractorUserIntegrate(
      this.state.field_id,
      this.tempParamFetch
    )
      .then(res => {
        let integrateSuccessModal = null;
        if (res.result) {
          EventManager.trigger(EventType.REFRESH_PROFILE);
          integrateSuccessModal = {
            title: INTEGRATE_USER_SUCCESS_TITLE,
            message: INTEGRATE_USER_SUCCESS_MESSAGE,
          };
        }
        this.setState({
          showInformationModal: true,
          integrateSuccessModal,
          errorMessage: integrateSuccessModal
            ? ''
            : INTEGRATE_USER_COMMON_ERROR_MESSAGE,
        });
      })
      .finally(() => {
        this.closeDialog('showConfirmIntegrateUserDialog');
        this.updatingFlag = false;
      });
  };

  render() {
    const title = () => {
      if (_.has(this.state.jv, 'name')) {
        return `${this.state.jv.name}の確認 ・ 編集 ‐ 現場監督新規登録`;
      }
      return '現場監督新規登録';
    };

    return (
      <div className='slide-view__view sys-splitview-1'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 現場体制 (施工体系図)</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader title={title()} onClose={() => this.close()} />
          <div className='fieldstree-main'>
            <div className='fieldstree-main__menu fieldstree-main__under-bar'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button
                    className='btn--effective'
                    onClick={() => {
                      this.submit();
                    }}
                  >
                    登録
                  </button>
                </li>
                <li className='btn-menu__item --fx-auto' />
                <li className='btn-menu__item'>
                  <p className='slide-view__header-end-item'>
                    必須項目の入力数
                    <span className='sys-required'>
                      {' '}
                      {this.state.requiredInput.count}
                    </span>
                    /
                    <span className='sys-required_total'>
                      {this.state.requiredInput.total}
                    </span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className='slide-view__body_height'>
            <SupervisorForm
              companyBranchId={this.state.position_company_branch_id}
              values={this.state.formValues}
              roles={this.state.roles}
              disabledFields={this.state.disabledFields}
              forms={this.form}
              messages={this.state.validate.messages}
              newMode={this.isNewMode}
              jv={this.state.jv_id}
              my_branch={this.state.my_branch}
              callback={this.handleChangeBranch}
            />
          </div>
          <ConfirmExistedEmailDialog
            visible={this.state.showConfirmExistedEmailDialog}
            isCreateNew={this.isNewMode}
            userRoleCode={this.state.formValues.role_code}
            onCancel={() => this.closeDialog('showConfirmExistedEmailDialog')}
            onConfirmIntegrate={this.confirmIntegrate}
            onConfirmNotIntegrate={() => {
              this.setState({
                showConfirmExistedEmailDialog: false,
                showConfirmation: true,
              });
            }}
          />
          <ConfirmIntegrateUserDialog
            visible={this.state.showConfirmIntegrateUserDialog}
            onConfirm={this.confirmIntegrateUser}
            data={this.state.listIntegrateUsers}
            onCancel={() => this.closeDialog('showConfirmIntegrateUserDialog')}
          />
          <IntegrateError
            visible={this.state.showIntegrateError}
            reason={this.state.integrateErrorMessage}
            onCancel={() => this.closeDialog('showIntegrateError')}
          />
          <Information
            title={messageUtility.getMessage('E-001-402')}
            message={this.state.errorMessage}
            {...this.state.integrateSuccessModal}
            visible={this.state.showInformationModal}
            buttonText={messageUtility.getMessage('I-000-017')}
            onClose={() => this.closeDialog('showInformationModal')}
            multilineText={true}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldTreeForm.jsx